// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-md":"768px","header":"Headings_header__1s4xB","anchor":"Headings_anchor__8SWYa","title":"Headings_title__25e4T","subtitle":"Headings_subtitle__1rPb6"};